<template>
  <div class="body" :key="Math.random()">
    <div class="common-page dark-theme">
      <div class="wrap">
        <h1 class="logo">
          <a href="/index.html">
            <img src="../../assets/images/common/ci-wavve.svg" alt="Wavve" />
          </a>
        </h1>
      </div>
      <div class="tAc">
        <h2 tabindex="0">사용자 변경</h2>
        <h3 tabindex="0">시청할 프로필을 선택하세요.</h3>
        <div class="user-wrap01">
          <div v-for="(profile, index) in profileList" :key="profile.image + index" class="user-style">
            <a href="#" @click.prevent="setProfile(profile.profileid)">
              <div class="user-img"><img :src="getImage(profile.image)" :alt="profile.alt"/></div>
            </a>
            <a href="#" @click.prevent="profileUpdate(profile.profileid)">
              <strong class="profile-change-name">{{ profile.profilename }}</strong>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { changeProfileProc } from '@/common/utils/login'
import { getUserProfileList } from '@/common/utils/request'
import { imageUrl } from '@/common/filters/url.filter'
import shave from 'shave'
import _ from 'lodash'
import { PATH_NAME_HOME, PATH_NAME_PROFILE_EDIT } from '@/common/resources/router.const'
import { titleTagNameChange } from '@/common/utils/common'
import { resizeThumbnail } from '@/common/utils/image'
import { FLUSH_EVENT } from '@/common/resources/const'
export default {
  data () {
    return {
      profileId: 0,
      profileList: [],
      isLoading: true
    }
  },
  filters: {
    imageUrl
  },
  methods: {
    getImage (url) {
      return resizeThumbnail(url, { width: 0, height: 0, option: 20, quality: 80 })
    },
    setProfile (profileId) {
      if (this.profileId !== profileId) {
        this.$events.$emit(FLUSH_EVENT)
        changeProfileProc({ profileId }).then(() => {
          this.$router.push({ name: PATH_NAME_HOME })
        })
      } else {
        this.$router.push({ name: PATH_NAME_HOME })
      }
    },
    profileUpdate (profileId) {
      this.$router.push({
        name: PATH_NAME_PROFILE_EDIT,
        query: {
          profileId: profileId,
          pageType: 'memberSelect'
        }
      })
    }
  },
  created () {
    this.isLoading = true
    this.profileList = []
    getUserProfileList({ offset: 0, limit: 10, orderby: 'old' }).then(({ data }) => {
      this.profileList = _.get(data, 'list', [])
      this.isLoading = false
    })
    titleTagNameChange('사용자 변경 : 웨이브')
  },
  mounted () {
    shave('.profile-change-name', 26)
  }
}
</script>
